/// <amd-module name="Artifacts/Pypi/services/PyPiRestApiUrlGeneratorService" />
import { getFeedNameWithNewView } from "Artifacts/Root/helpers/FeedHelpers";
import { IFeed } from "Artifacts/Root/types/IFeed";
import { generatePackagingServiceRestApiUri, IRestApiRoutes } from "Artifacts/Root/Utils/RestApi";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

const PyPiArea = "pypi";

const PyPiSimplePackageNameLocationId: IRestApiRoutes = {
  locationId: "93377A2C-F5FB-48B9-A8DC-7781441CABF1",
  resource: "simple",
  routeTemplate: "_packaging/{feedId}/{area}/{resource}/{packageName}/",
};

const PyPiPackagesLocationId: IRestApiRoutes = {
  locationId: "C7A75C1B-08AC-4B11-B468-6C7EF835C85E",
  resource: "upload",
  routeTemplate: "_packaging/{feedId}/{area}/{resource}",
};

const PyPiPackageContentLocationId: IRestApiRoutes = {
  locationId: "97218BAE-A64D-4381-9257-B5B7951F0B98",
  resource: "content",
  routeTemplate:
    "packaging/feeds/{feedId}/{area}/packages/{packageName}/versions/{packageVersion}/{fileName}/{resource}",
};

export interface IPyPiRestApiUrlGeneratorService extends IVssService {
  getSimplePackageNameUrl(
    feedId: string,
    includeProject: boolean,
    packageName: string,
    publicAccessMapping: string,
  ): string;
  getPackageUploadUrl(feedId: string, includeProject: boolean, publicAccessMapping: string): string;
  getFileDownloadUrl(
    feed: IFeed,
    packageName: string,
    packageVersion: string,
    fileName: string,
    publicAccessMapping: string,
  ): string;
}

class PyPiRestApiUrlGeneratorService extends VssService implements IPyPiRestApiUrlGeneratorService {
  public getSimplePackageNameUrl(
    feedId: string,
    includeProject: boolean,
    packageName: string,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(PyPiSimplePackageNameLocationId.routeTemplate, {
      feedId,
      area: PyPiArea,
      resource: PyPiSimplePackageNameLocationId.resource,
      packageName,
    });

    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      true /* ignoreApisRelativePath */,
      includeProject,
    );
  }
  public getPackageUploadUrl(
    feedId: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(PyPiPackagesLocationId.routeTemplate, {
      feedId,
      area: PyPiArea,
      resource: PyPiPackagesLocationId.resource,
    });

    return generatePackagingServiceRestApiUri(
      this.pageContext,
      publicAccessMapping,
      path,
      true /* ignoreApisRelativePath */,
      includeProject,
    );
  }
  public getFileDownloadUrl(
    feed: IFeed,
    packageName: string,
    packageVersion: string,
    fileName: string,
    publicAccessMapping: string,
  ): string {
    const feedId = getFeedNameWithNewView(feed.id, feed.selectedViewId);
    const path = replaceRouteValues(PyPiPackageContentLocationId.routeTemplate, {
      feedId,
      area: PyPiArea,
      resource: PyPiPackageContentLocationId.resource,
      packageName,
      packageVersion,
      fileName,
    });

    const includeProject = feed && feed.project != null;
    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      false /* ignoreApisRelativePath */,
      includeProject,
    );
  }
}

Services.add("IPyPiRestApiUrlGeneratorService", { serviceFactory: PyPiRestApiUrlGeneratorService });
